export default __webpack_public_path__ + "static/media/gsm_3.422f8448.svg";